import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import PageLayout from "../components/layout/PageLayout";
import { LoadingOverlay } from "../components/ui/loading-overlay";
import { fetchWithAuth } from "../Context/UserContext";
import API_URL from "../config";
import InfoCatalogo from "../Catalogo/InfoCatalogo";
import ModalContacto from "../Catalogo/ModalContacto";

const Favoritos = () => {
  const [empresas, setEmpresas] = useState([]);
  const [favoritosIds, setFavoritosIds] = useState(new Set());
  const [isLoading, setIsLoading] = useState(true);
  const [selectedEmpresa, setSelectedEmpresa] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);

  const fetchFavoritos = async () => {
    setIsLoading(true);
    try {
      const response = await fetchWithAuth(`${API_URL}/catalogo/favoritos`);
      if (response.ok) {
        const { empresas: favoritos } = await response.json();
        setEmpresas(favoritos);
        setFavoritosIds(new Set(favoritos.map((e) => e.id_company)));
      }
    } catch (error) {
      console.error("❌ Error al obtener favoritos:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFavoritos();
  }, []);

  const handleToggleFavorito = async (empresa) => {
    try {
      const response = await fetchWithAuth(`${API_URL}/catalogo/favoritos/${empresa.id_company}`, {
        method: "DELETE",
      });
      if (response.ok) {
        setEmpresas((prev) => prev.filter((e) => e.id_company !== empresa.id_company));
        setFavoritosIds((prev) => {
          const next = new Set(prev);
          next.delete(empresa.id_company);
          return next;
        });
      }
    } catch (error) {
      console.error("❌ Error al quitar favorito:", error);
    }
  };

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <PageLayout>
      <Helmet>
        <title>Mis proveedores favoritos - Procu</title>
      </Helmet>

      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <h1 className="text-2xl font-semibold text-foreground">Mis proveedores favoritos</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Los proveedores que guardaste para encontrarlos rápido.
        </p>

        <div className="mt-6">
          <InfoCatalogo
            empresas={empresas}
            page={1}
            totalPages={1}
            setPage={() => {}}
            onNextPage={() => {}}
            onPreviousPage={() => {}}
            clearFilters={() => {}}
            onContact={(empresa) => {
              setSelectedEmpresa(empresa);
              setShowContactModal(true);
            }}
            favoritosIds={favoritosIds}
            onToggleFavorito={handleToggleFavorito}
          />
        </div>
      </div>

      <ModalContacto
        show={showContactModal}
        onClose={() => setShowContactModal(false)}
        empresa={selectedEmpresa}
      />
    </PageLayout>
  );
};

export default Favoritos;
